export default __webpack_public_path__ + "static/media/blogPropsGithubLogo.271c27d7.PNG";